// src/contexts/AuthContext.tsx
import React, { createContext, useContext, useEffect, useState } from "react";
import { onAuthStateChanged, User } from "firebase/auth";
import { auth } from "../firebase";
import api from "../services/api";

interface AuthContextProps {
  user: User | null;
  setUser: (user: User | null) => void;
  register: (
    firstName: string,
    lastName: string,
    email: string,
    password: string,
  ) => Promise<void>;
  loading: boolean;
}

const AuthContext = createContext<AuthContextProps | undefined>(undefined);

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      console.log("Auth state changed:", user);
      setUser(user);
      if (!user) {
        localStorage.clear();
      } else {
        const produktly = (window as any).Produktly;
        // produktly?._identifyUser(user.uid);
      }
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);

  const register = async (
    firstName: string,
    lastName: string,
    email: string,
    password: string,
  ): Promise<void> => {
    try {
      await api.post("/api/v1/auth/register", {
        firstName,
        lastName,
        email,
        password,
      });
    } catch (error) {
      console.error("Failed to register:", error);
      throw error; // Rethrow to handle in the calling component
    }
  };

  return (
    <AuthContext.Provider value={{ user, setUser, loading, register }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
